@if (type === 'path') {
    <a [routerLink]="link">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
}

@if (type === 'link') {
    <a [href]="link">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
}

<ng-template #content>
    <ng-content></ng-content>
</ng-template>
